export default [
  {
    sourceType: "messenger",
    title: "Мессенджеры",
    description: "Выберите название мессенджера",
  },
  {
    sourceType: "forum",
    title: "Форумы",
    description: "Введите название форума",
  },
  {
    sourceType: "site",
    title: "Сайты",
    description: "Выберите название сайта",
  },
  {
    sourceType: "api",
    title: "API",
    description: "Выберите API",
  }
];



// WEBPACK FOOTER //
// ./src/components/pages/Ledger/sources.js